import React, { useEffect, useState } from 'react'
import axios from 'axios'
import { Link, useNavigate } from 'react-router-dom'
import { AiFillLike , AiFillDislike,AiFillDelete} from "react-icons/ai";






function AllPost() {

    const [data, setData] = useState([])
    const [token, setToken] = useState('')
    const [user, setUser] = useState('')



    useEffect(() => {
        axios.get('https://rahulbloging.onrender.com/getAllPost')

            .then((result) => {
                console.log(result.data.data)
                setData(result.data.data)
            })
            .catch((err) => {
                console.log(err)

                alert(err.response.data.msg)
            })

    }, [])

    useEffect(() => {

        setToken(localStorage.getItem('token'))
        setUser(localStorage.getItem('useuserId'))

    }, [data])




    const navigate = useNavigate()

    const DeletePost = async (a) => {
           console.log("Rahul chaudhary bbb")
        // e.preventDefault()
            
        await axios.delete('https://rahulbloging.onrender.com/deletPost', {
            headers: {
                'UserId': a,
                'token': token
            }
        })

            .then((result) => {
              
                console.log(result.data.data)
                alert('Post Delete SuccesFully')
                navigate('/')

            })
            .catch((err) => {
                console.log(err)

                alert(err.response.data.msg)
            })


    }






    const LikeUpdate = async (id) => {
        
        await axios.post('https://rahulbloging.onrender.com/like',{
      headers: {
        'UserId':user,
        'PostId':id
      }
    })

      .then((result) => {
        console.log(result.data.data)
        alert(result.data.msg)
        navigate('/allPost')
       
      })
      .catch((err) => {
        console.log(err)

        alert(err.response.data.msg)
      })

    }


    const UnLikeUpdate = async (id) => {
        
        await axios.post('https://rahulbloging.onrender.com/UnLike',{
      headers: {
        'UserId':user,
        'PostId':id
      }
    })

      .then((result) => {
        console.log(result.data.data)
        alert(result.data.msg)
        navigate('/allPost')
       
      })
      .catch((err) => {
        console.log(err)

        alert(err.response.data.msg)
      })

    }

















    return (
        <div id='a'>

            <div className="container d-flex flex-wrap ">

                {/* <button onClick={handlePost} className='btn m-3 bg-danger'>click me</button> */}

                {
                  data.length == 0 ? 
                    <div className="round">
                         <div class="loader"></div>
                    </div> 
                    :
                    data.map((a) => {

                        return (

                            <div >

                                <div id='main' className='card m-1 ' style={{ width: "420px",height:"480px", maxHeight:"500px"}}>

                                    <div class="card m-2 bg-info" style={{ width: "400px",objectFit:"fill"  }}>
                                        <img src={a.imageUrl} class="card-img-top  " alt="..."  style={{ height:"320px",objectFit:"fill"  }} />

                                        <div class="card-img-overlay ">
                                            <h onClick={() => DeletePost(a._id)} id='delete' to="#" ><AiFillDelete/></h>
                                        </div>

                                        <div class="card-body">
                                            <h3 style={{textAlign:'center'}}>{a.title}</h3>
                                            <p style={{color:"black"}} class="card-text"> {a.description}</p>
                                        </div>


                                    </div>
                                   
                                      <div className='d-flex'>
                                        <Link id='l' onClick={()=>LikeUpdate(a._id)}><AiFillLike/></Link>
                                       <h1 id='ll'> {a.like}</h1>
                                        <Link id='l' onClick={()=>UnLikeUpdate(a._id)}><AiFillDislike/></Link>
                                      </div>

                                </div>

                            </div>


                        )

                    })
                }


            </div>




        </div>
    )
}

export default AllPost
